'use client';

import { Link } from '@/i18n/navigation';
import { useSearchParams } from 'next/navigation';

function PreviousLink() {
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams);
  const page = searchParams.get('page') ?? '1';
  const previousPage = parseInt(page, 10) - 1;
  const disabled = previousPage < 1;

  params.set('page', previousPage.toString());

  if (disabled) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a role='link' className='pagination__link' aria-disabled>
        &laquo;
      </a>
    );
  }

  return (
    <Link
      href={`?${params.toString()}`}
      aria-label={`Vorherige Seite, Seite ${previousPage}`}
      className='pagination__link'
    >
      &laquo;
    </Link>
  );
}

export default PreviousLink;
